<template>
  <div class="page-title">
    <div class="row">
      <div class="col-sm-6 col-12">
        <h2>Accounts</h2>
      </div>
      <div class="col-sm-6 col-12 text-end">
        <a :href="`/service-provider/${props.serviceProviderId}/account/new`" class="btn btn-primary">
          <i class="fa fa-plus"></i> Create Account
        </a>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header card-no-border pb-0">
      <ul class="nav nav-tabs" id="accounts-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link" id="all-accounts-tab" data-bs-toggle="tab"
             href="#all-accounts" role="tab" aria-selected="false">
            <i class="fa-solid fa-building text-primary"></i>
            All Accounts
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" id="active-accounts-tab" data-bs-toggle="tab"
             href="#active-accounts" role="tab" aria-selected="true">
            <i class="fa-solid fa-check-circle text-success"></i>
            Active
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="inactive-accounts-tab" data-bs-toggle="tab"
             href="#inactive-accounts" role="tab" aria-selected="false">
            <i class="fa-solid fa-pause-circle text-warning"></i>
            Inactive
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="closed-accounts-tab" data-bs-toggle="tab"
             href="#closed-accounts" role="tab" aria-selected="false">
            <i class="fa-solid fa-ban text-danger"></i>
            Closed
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content" id="accounts-tabContent">
        <div class="tab-pane fade" id="all-accounts" role="tabpanel">
          <DataTable
              :ajax="{ url: allAccountsUrl }"
              ref="allAccountsTable"
              class="table-responsive display"
              :columns="columnDefinition"/>
        </div>

        <div class="tab-pane fade show active" id="active-accounts" role="tabpanel">
          <DataTable
              :ajax="{ url: activeAccountsUrl }"
              ref="activeAccountsTable"
              class="table-responsive display"
              :columns="columnDefinition"/>
        </div>

        <div class="tab-pane fade" id="inactive-accounts" role="tabpanel">
          <DataTable
              :ajax="{ url: inactiveAccountsUrl }"
              ref="inactiveAccountsTable"
              class="table-responsive display"
              :columns="columnDefinition"/>
        </div>

        <div class="tab-pane fade" id="closed-accounts" role="tabpanel">
          <DataTable
              :ajax="{ url: closedAccountsUrl }"
              ref="closedAccountsTable"
              class="table-responsive display"
              :columns="columnDefinition"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {accountStatus, currency} from '../utility/DatatableRenderer';
import {newEntityId} from '../globals.js';

DataTable.use(DataTablesCore);

const props = defineProps({
  serviceProviderId: {type: String, default: newEntityId}
});

const allAccountsTable = ref(null);
const activeAccountsTable = ref(null);
const inactiveAccountsTable = ref(null);
const closedAccountsTable = ref(null);

const allAccountsUrl = `/api/datatable/sp-accounts/${props.serviceProviderId}`;
const activeAccountsUrl = `${allAccountsUrl}?status=ACTIVE`;
const inactiveAccountsUrl = `${allAccountsUrl}?status=INACTIVE`;
const closedAccountsUrl = `${allAccountsUrl}?status=CLOSED`;

const columnDefinition = [
  {
    title: "Account ID",
    data: "accountCode",
    render: (data, type, row) => {
      return `<a href="/service-provider/${props.serviceProviderId}/account/${row.id}" class="text-primary fw-bold">${data}</a>`;
    }
  },
  {
    title: "Company Name",
    data: "companyName",
    render: DataTablesCore.render.ellipsis(40, true)
  },
  {
    title: "Billing Cycle",
    data: "billingCycle",
    render: (data) => {
      const cycles = {
        'PER_TRIP': 'Per Trip',
        'WEEKLY': 'Weekly',
        'BIWEEKLY': 'Bi-Weekly',
        'MONTHLY': 'Monthly',
        'QUARTERLY': 'Quarterly'
      };
      return cycles[data] || data;
    }
  },
  {
    title: "Current Balance",
    data: "currentBalance",
    render: (data) => currency(data || 0)
  },
  {
    title: "Credit Limit",
    data: "creditLimit",
    render: (data) => data > 0 ? currency(data) : '<span class="text-muted">Unlimited</span>'
  },
  {
    title: "Status",
    data: "status",
    render: accountStatus
  },
  {
    title: 'Actions',
    orderable: false,
    searchable: false,
    render: (data, type, row) => {
      return `
        <div class="btn-group">
          <a class="btn btn-sm btn-outline-primary" href="/service-provider/${props.serviceProviderId}/account/${row.id}">
            <i class="iconly-Info-Circle icbr"></i> View
          </a>
        </div>
      `;
    }
  }
];
</script>
